import { DataSourcePlugin } from './dataSource';
import { FormPlugin } from './form';
import { MockProxyPlugin } from "../../../lib/builtin/plugins/MockProxy/MockProxy";
import { FakeDataSourcesPlugin } from './fakeDataSources';
import { CompActionsPlugin } from './CompActions/index';
import { FitDataReplacePlugin } from "../../../lib/builtin/plugins/FitDataReplacePlugin";
import { CompReplacePlugin } from './CompReplacePlugin/index';
import { StyleConvertPlugin } from './StyleConvertPlugin';
export const builtinPlugins = {
  dataSource: new DataSourcePlugin(),
  fakeDataSources: new FakeDataSourcesPlugin(),
  form: new FormPlugin(),
  mockProxy: new MockProxyPlugin(),
  compActions: new CompActionsPlugin(),
  fitDataReplace: new FitDataReplacePlugin(),
  compReplace: new CompReplacePlugin(),
  styleConvertPlugin: new StyleConvertPlugin()
};